import React from 'react';
import { Link } from 'react-router-dom';
import './Product.css';

const ProductItem = ({number, id, productCategoryName, score, info, status,
    deleteProduct, address,deleteLoading, updateLoading, unit, blockingProduct,
    getProductInfoForUpdate, title, telephone, minValue, ourPrice, generalPrice}) => {
        
    return ( 
        <div className="product-item-layer">
            <span className="align-self-center product-item-layer-number">
                <span>{number}</span>
            </span>
            <div className="align-self-center d-flex flex-column justify-content-between align-items-start px-2 py-1">
                <small className="font-weight-bold">
                    <span >عنوان</span>
                    <span className="mx-1">:</span>
                    <span className="text-muted">{title}</span>
                </small>
                <small className="font-weight-bold">
                    <span >واحد</span>
                    <span className="mx-1">:</span>
                    <span className="text-muted">{unit}</span>
                </small>
                <small className="font-weight-bold">
                    <span >دسته بندی</span>
                    <span className="mx-1">:</span>
                    <span className="text-muted">{productCategoryName}</span>
                </small>
                <small className="font-weight-bold">
                    <span >قیمت واحد ما</span>
                    <span className="mx-1">:</span>
                    <span className="text-muted">{ourPrice}</span>
                </small>
                <small className="font-weight-bold">
                    <span >قیمت واحد بازار</span>
                    <span className="mx-1">:</span>
                    <span className="text-muted">{generalPrice}</span>
                </small>
                <small className="font-weight-bold">
                    <span >حداقل میزان خرید</span>
                    <span className="mx-1">:</span>
                    <span className="text-muted">{minValue} {unit}</span>
                </small>
                <div className="" style={{height:'15px'}}>
                        <p className="ratings">
                            <Link to='' onClick={ event => event.preventDefault()}>
                                <span className={score >= 5 ? "fa fa-star" : "fa fa-star-o"}></span>
                            </Link>
                            <Link to='' onClick={ event => event.preventDefault()}>
                                <span className={score >= 4 ? "fa fa-star" : "fa fa-star-o"}></span>
                            </Link>
                            <Link to='' onClick={ event => event.preventDefault()}>
                                <span className={score >= 3 ? "fa fa-star" : "fa fa-star-o"}></span>
                            </Link>
                            <Link to='' onClick={ event => event.preventDefault()}>
                                <span className={score >= 2 ? "fa fa-star" : "fa fa-star-o"}></span>
                            </Link>
                            <Link to='' onClick={ event => event.preventDefault()}>
                                <span className={score >= 1 ? "fa fa-star" : "fa fa-star-o"}></span>
                            </Link>
                            <Link to='' onClick={ event => event.preventDefault()} className="mark">{score}</Link>
                        </p>
                    </div>
            </div>
            <div className="align-self-center d-flex flex-column justify-content-between align-items-start px-2 py-1"
                style={{maxWidth:'170px'}}
            >
                <small className="font-weight-bold" style={{height:'60px', overflow:'auto'}}>
                    <span >آدرس</span>
                    <span className="mx-1">:</span>
                    <span className="text-muted">{address}</span>
                </small>
                <small className="font-weight-bold" style={{height:'60px', overflow:'auto'}}>
                    <span >توضیحات</span>
                    <span className="mx-1">:</span>
                    <span className="text-muted">{info}</span>
                </small>
                <small className="font-weight-bold">
                    <span >تلفن</span>
                    <span className="mx-1">:</span>
                    <span className="text-muted">{telephone}</span>
                </small>
            </div>
            <div className="d-flex justify-content-center align-items-center flex-md-column small-margin-auto">
                <button className="btn btn-success mr-1 mr-md-0  mb-md-1 user-item-btn"
                    onClick={getProductInfoForUpdate}
                >
                    <i 
                        className={ updateLoading.flag && updateLoading.id === id  ? 
                        'spinner-border spinner-border-sm operator-button': 'fa fa-pencil'} 
                    ></i>
                </button>
                <button className="btn btn-danger product-item-btn"
                    onClick={deleteProduct}
                >
                    <i 
                        className={deleteLoading.flag && deleteLoading.id === id? 
                        'spinner-border spinner-border-sm operator-button': 'fa fa-trash'} 
                    ></i>
                </button>
                <button className={`btn  product-item-btn ml-1 ml-md-0  mt-md-1 ${status === 'Enable' ? ' btn-primary' : ' btn-secondary'}`}
                    onClick={() => blockingProduct(id)}
                >
                    <i className={status==='Enable' ? 'fa fa-ban' : 'fa fa-ban'}></i>
                </button>
            </div>
        </div>

     );
}
 
export default ProductItem;